import React from "react";
import ToggleSwitch from "../common/ToggleSwitch";

const ReferralSettings = ({ autoAcceptAWSReferrals, setAutoAcceptAWSReferrals }) => {
  return (
    <div className="automation-section">
      <div className="automation-section-title">Referral Settings</div>
      <div className="automation-row">
        <ToggleSwitch
          label="Auto-Accept AWS Referrals"
          value={autoAcceptAWSReferrals}
          onChange={setAutoAcceptAWSReferrals}
        />
      </div>
    </div>
  );
};

export default ReferralSettings;
